//英文
export default {
    login_module: {
        Login: 'Login',
        Register: 'Register',
        noAccount: "Don't have a account yet?",
        hasAccount: 'Already have an account?',
        IAgree: 'I agree with',
        rememberMe: 'Remember me',
        lostPassword: 'Lost password',
        send: 'Send',
        userName: 'user Name',
        mailAddress: 'E-mail Address',
        pwdFormat: 'The password must contain 6 to 18 digits and letters.',
        pwdConfirmFormat: 'Not the same password entered in both fields.',
        pasConfirm: 'Password Confirmation',
        pleaseInput: 'Please enter',
        name: 'Name',
        inputName: 'Please enter your name',
        userNameFormat: 'User name may only contain alphanumeric characters or single hyphens, and cannot begin or end with a hyphen.',
        password: 'Password',
        email: 'E-mail',
        inputEmail: 'Please enter email',
        emailFormatError: 'Email format error',
        enterEmail: 'Enter your e-mail below and we will send you reset instructions.',
        selectCountry: 'Select Country',
        verificationCode: 'Verification code',
        verificationFormat: 'The verification code is incorrect.',
        CountryRegion: 'Country/Region ',
        inputPwd: 'Please enter the password',
        activationPrompt: 'We will send an activation email to your email. Please activate it in your email before logging in.'
    },
    overview_module: {
        //overview
        today: 'Today',
        detectionQuantity: 'Detection Quantity',
        abnormalQuantity: 'Abnormal Quantity',
        dailyDetection: 'Daily detection',
        detectionItems: 'Detect items',
        bloodSugar: 'blood sugar',
        bloodKetones: 'blood ketones',
        uricAcid: 'uric acid',
        lactate: 'Lactate',
        mailbox: 'Mailbox',
        detectionTime: 'Detection time',
        detectionValue: 'Detection value',
        unit: 'Unit',
        search: 'Search',
        enterName: 'Enter name',
        gender: 'Gender',
        male: 'Male',
        female: 'Female',
        date: 'date',
        //时段
        allGlucose: 'All blood glucose',
        midnight: 'Midnight',
        earlyMorning: 'Early Morning',
        afterBreakfast: 'After Breakfast',
        beforeLunch: 'Before Lunch',
        afterLunch: 'After Lunch',
        beforeDinner: 'Before Dinner',
        afterDinner: 'After Dinner',
        bedtime: 'Bedtime'
    },
    table: {
        all: 'All',
        display: 'Display',
        records: 'records',
        unused: 'unused',
        used: 'used',
    },
    aside: {
        //侧边栏
        overview: 'Overview',
        myPatients: 'My patients',
        personalInfo: 'Personal information',
        allPatients: 'All patients',
        inviteCodes: 'Invitation codes',
        code: 'Code',
        changePwd: 'Change password',
        allDoctors: 'All doctors',
        allAgent: 'All agent',
        allInviteCodes: 'All invitation codes',
        operations: 'Operations',
        feedback: 'Feedback',
        software: 'Software'
    },
    footer: {
        service: 'Privacy and Terms of Service',
        support: 'Get Support'
    },
    patient_module: {
        //patient
        remind: 'Remind',
        sendMsg: 'Send message',
        DMType: 'DM Type',
        lastUploadTime: 'Last upload time',
        device: 'Device',
        lastMeasureTime: 'Last detection time',
        country: 'Country',
        type1: 'Type I',
        type2: 'Type II',
        otherForms: 'Other forms',
        GDM: 'Gestational type',
        typePre: 'Prediabetes',
        typeSpecial: 'Special type',
    },
    patient_detail_module: {
        confirmationTime: 'DM Time',
        addNote: 'Add a note',
        enterNote: 'Please enter note information',
        editNote: 'Editors note',
        confirmDeleteNote: 'Sure to delete note?',
        unbind: 'Unbind',
        table: 'Table',
        logbook: 'Logbook',
        trends: 'Trends',
        period: 'Period',
        Days: 'Days',
        other: 'Others',
        AvgDailyRange: 'Avg Daily Readings In Range',
        AvgDailyNo: 'Daily average of the  number of BGM readings',
        readingRange: 'Readings in range',
        avgBG: 'Avg Blood Glucose',
        DerivedFrom: 'Derived from',
        BGMReadings: 'BGM readings',
        weeks: 'Weeks',
        monday: 'M',
        tuesday: 'Tu',
        wednesday: 'W',
        thursday: 'Th',
        friday: 'F',
        saturday: 'Sa',
        sunday: 'Su',
        group: 'Group',
        range: 'Range',
        avg: 'Average',
        patientMGT: 'Patient management',
        medicine: 'Medicine',
        food: 'Food',
        sport: 'Sport',
        DMInfo: 'Diabetes information',
        height: 'Height',
        weight: 'Weight',
        PreMealSugarCtrlTgt: 'Pre-meal sugar control target',
        PostprandialSugarCtrlTgt: 'Postprandial sugar control target',
        info: 'information',
        useDevice: 'Device',
        associatedDoc: 'Associated doctor',
        associatedAgent: 'Associated agent',
        lastLoginTime: 'Last login time',
        uploadMethod: 'Upload method',
        addMethod: 'How to add it',
        manualAddition: 'manual addition',
        realTime: 'real-time measurement',
        historical: 'historical measurement',
        recordTime: 'Record time',
        dose: 'Dose',
        type: 'Type',
        calories: 'Calories',
        carbs: 'Carbs',
        proteins: 'Proteins',
        fats: 'Fats',
        strength: 'Strength',
        duration: 'Duration',
        sendCustomerConfirm: 'We will send the content directly to the customer, please confirm it repeatedly.',
        selectExportedTime: 'Select the time range of the exported data',
        from: 'from',
        to: 'to',
        verificationCode: 'Verification code',
        verificationFormat: 'The verification code is incorrect.',
        DetectionStats: 'Detection statistics',
        addedToday: 'Added today',
        addedWeek: 'Added this week',
        addedMonth: 'Added this month',
        remarksNoEmpty: 'Remarks can not be empty',
        selectTableTime: 'Select the time range of the table data',
        startDate: 'Start Date',
        endDate: 'End Date',
        belowRange: 'Readings Below Range',
        inRange: 'Readings In Range',
        aboveRange: 'Readings Above Range'
    },
    weekdays: {
        Sun: 'Sun',
        Mon: 'Mon',
        Tue: 'Tue',
        Wed: 'Wed',
        Thu: 'Thu',
        Fri: 'Fri',
        Sat: 'Sat'
    },
    info_module: {
        basicInfo: 'Basic information',
        avatar: 'Avatar',
        birthday: 'Birthday',
        chooseDate: 'choose date',
        selfIntro: 'Self introduction',
        PEIntro: 'Introduction to professional experience',
        oldPwd: 'Old Password',
        newPwd: 'New Password',
        inputOldPwd: 'Please enter the old password',
        inputNewPwd: 'Please enter a new password',
        inputPwdAgain: 'Please enter your password again'
    },
    invite_module: {
        add: 'Add',
        Use: 'Use',
        pushMail: 'Push mailbox',
        remarks: 'Remarks',
        creationTime: 'Creation Time',
        action: 'Action',
        generateCode: 'Generate invitation code',
        codeInfo: 'We will send an e-mail with the activation code to the e-mail address.Please remind your patient to check it.'
    },
    operation: {
        promot: 'Prompt',
        edit: 'Edit',
        save: 'Save',
        yes: 'yes',
        delete: 'Delete',
        saveSend: 'Save and send',
        rePush: 'Re-push',
        cancel: 'cancel',
        exit: 'Log out',
        confirmExit: 'Are you sure to log out?',
        confirmDelete: 'Confirm deletion?',
        addSuccessed: 'Successfully added!',
        editSuccessed: 'Updated successfully!',
        successfullyDelete: 'successfully delete!'
    }
}


// WEBPACK FOOTER //
// ./src/i18n/lang/en.js